import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const toggleDefaultVariants = {}
const toggleCompoundVariants = []

const toggleSlotNames = [
  [
    "container",
    "toggle__container"
  ],
  [
    "input",
    "toggle__input"
  ],
  [
    "indicator",
    "toggle__indicator"
  ],
  [
    "background",
    "toggle__background"
  ]
]
const toggleSlotFns = /* @__PURE__ */ toggleSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, toggleDefaultVariants, getSlotCompoundVariant(toggleCompoundVariants, slotName))])

const toggleFn = memo((props = {}) => {
  return Object.fromEntries(toggleSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const toggleVariantKeys = []
const getVariantProps = (variants) => ({ ...toggleDefaultVariants, ...compact(variants) })

export const toggle = /* @__PURE__ */ Object.assign(toggleFn, {
  __recipe__: false,
  __name__: 'toggle',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: toggleVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, toggleVariantKeys)
  },
  getVariantProps
})